<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <import-template-edit-form
        @on-submit="onImportEditSubmit"
      ></import-template-edit-form>
    </div>
  </div>
</template>
<script>
import ImportTemplateEditForm from "./ImportTemplateEditForm.vue";

export default {
  components: {
    ImportTemplateEditForm
  },
  data() {
    return {
      importTemplateEditModel: {}
    };
  },
  methods: {
    onImportEditSubmit(model) {
      this.importTemplateEditModel = model;
      // this.$http.post(
      //   this.$apiBaseUrl + 'imports/' + this.importTemplateEditModel.id, Object.assign(this.importTemplateEditModel)
      // ).then(response => {
      // }, response => {
      // });
    }
  }
};
</script>
<style></style>
